module.exports = __webpack_public_path__ + "media/3-11.b7a12b13.wav";